import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { setLocale } from 'yup';

//Redux
import { Provider } from 'react-redux';
import store from './store';
import AppRoutes from './AppRoutes';
import withClearCache from './ClearCache';

import formikLocale from './constants/formikLocale';
import SessionWatcher from './components/auth/SessionWatcher';

const ClearCacheComponent = withClearCache(MainApp)

function App() {
  return <ClearCacheComponent />
}

//Función principal
function MainApp(props) {
  //Inicializo el locale de formik
  setLocale(formikLocale);
  return (
    <Provider store={store}>
      <SessionWatcher />

      <Router>
        <AppRoutes />
      </Router>
    </Provider>
    );
  }
  
  export default App;
  